module.exports = __webpack_public_path__ + "01ea978f/img/chevron-down-icon.5542f65c.svg";